function shopliftTest() {
  let hypothesisID = "96561a45-cf6a-430b-a995-2d8d23ecaed6"; //the shopplift test ID
  const body = document.body; //select the parent element for the test, or body if not available straight away
  window.shoplift.isHypothesisActive(hypothesisID).then((active) => {
    if (active) {
      const shopliftObserver = new MutationObserver((mutations, obs) => {
        changes();
      });

      shopliftObserver.observe(body, {
        childList: true,
        subtree: true,
      });
    }
  });

  function changes() {
    const stars = document.querySelectorAll(".ProductItem__Stars");
    stars.forEach((star) => {
      star.style.display = "block";
      shopliftObserver.disconnect();
    });
  }
}

if (window.theme.pageType == "collection") {
  document.addEventListener("DOMContentLoaded", function () {
    shopliftTest();
  });
}
